function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFertilizerSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 546",
    transform: "translate(7 7)",
    style: {
      stroke: "#f5f5f5",
      strokeWidth: 6
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 15,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2797"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2745",
    d: "M14.63 9.712a.7.7 0 0 1-.495-.2 3.091 3.091 0 0 0-4.27 0 .7.7 0 0 1-.99-.99 4.418 4.418 0 0 1 6.25 0 .7.7 0 0 1-.495 1.195M16.6 7.74a.7.7 0 0 1-.495-.2 5.815 5.815 0 0 0-8.215 0 .7.7 0 1 1-.99-.99 7.219 7.219 0 0 1 10.2 0 .7.7 0 0 1-.5 1.195m1.973-1.973a.7.7 0 0 1-.5-.2 8.605 8.605 0 0 0-12.16 0 .7.7 0 0 1-.991-.99 10.01 10.01 0 0 1 14.141 0 .7.7 0 0 1-.495 1.194",
    transform: "translate(7.275 7)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2798"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2799"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2746",
    d: "M18.931 5.478A6.581 6.581 0 0 1 15.84 13.3c-.177.1-.356.18-.537.258a3.953 3.953 0 0 1-.25.765 7.025 7.025 0 0 0 4.535-4.74 7.209 7.209 0 0 0-.011-4.164 5.693 5.693 0 0 0-.646.057",
    transform: "translate(6.394 14.009)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2747",
    d: "M5.872 14.268A6.548 6.548 0 0 1 .7 6.863a3.871 3.871 0 0 1-.526-.606 7.2 7.2 0 0 0 .678 4.995 7.121 7.121 0 0 0 4.756 3.594 5.824 5.824 0 0 0 .262-.577",
    transform: "translate(12 13.702)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2748",
    d: "M20.316 2.718a3.355 3.355 0 0 0-3.8-1.265 3.4 3.4 0 0 0-1.949 3.52c.029.215.129.334.3.354h.036a.322.322 0 0 0 .283-.173 5.565 5.565 0 0 1 2.18-1.463.323.323 0 0 0 .041-.016 5.514 5.514 0 0 1 2.588-.4.322.322 0 0 0 .351-.092.355.355 0 0 0-.021-.465",
    transform: "translate(6.585 15.539)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2749",
    d: "M5.475 3.717a.32.32 0 0 0-.307-.193 5.537 5.537 0 0 1-2.347-1.171.284.284 0 0 0-.034-.028A5.592 5.592 0 0 1 1.147.267.322.322 0 0 0 .892.006C.725-.026.6.061.5.26a3.424 3.424 0 0 0 .82 3.952 2.989 2.989 0 0 0 1.867.649 3.715 3.715 0 0 0 2.132-.708.352.352 0 0 0 .156-.435",
    transform: "translate(11.924 16)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2750",
    d: "M10.448 12.375a.346.346 0 0 0-.453.08.328.328 0 0 0-.012.365 5.637 5.637 0 0 1 .167 2.634.342.342 0 0 0-.006.044 5.636 5.636 0 0 1-.948 2.46.324.324 0 0 0 .25.569h.063a3.38 3.38 0 0 0 2.991-2.691 3.4 3.4 0 0 0-2.05-3.461",
    transform: "translate(8.619 11.472)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2751",
    d: "M10.407 8.385a1.5 1.5 0 1 0-.71.18 1.5 1.5 0 0 0 .71-.18",
    transform: "translate(9.505 14.395)",
    style: {
      strokeWidth: ".5px",
      fill: "none",
      stroke: "#f5f5f5"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFertilizerSensor);
export default __webpack_public_path__ + "static/media/fertilizer-sensor.be495070bdec55c8937ba939d18db157.svg";
export { ForwardRef as ReactComponent };